export enum VisaType {
    Tourist = 'tourist',
    Family = 'family',
    Work = 'work',
    Business = 'business',
    Transit = 'transit'
}
